import { useContext } from "react"
import styles from "./styles.module.scss"
import { Wrapper, Page, Fade } from "components"
import { Project } from "./Project"
import type { FC, HTMLAttributes } from "react"

interface SectionProps
extends HTMLAttributes<HTMLDivElement> {}


export const Section: FC<SectionProps> = ({ children, ...props }) => {
  const { content } = useContext(Page.Context)

  return (
    <Page.Section.Container id="projects" {...props}>
      <Fade>
        <Wrapper double>
          <Page.Section.Heading size="small">
            {content.projectsHeading}
          </Page.Section.Heading>
          <div className={styles.projects}>
            {content.projectsList.map((project, index) => (
              <Fade key={index}>
                <Project {...project} />
              </Fade>
            ))}
          </div>
        </Wrapper> 
      </Fade>
    </Page.Section.Container>
  )
}
